import { render, staticRenderFns } from "./Article0013.vue?vue&type=template&id=6744f8f8&scoped=true&"
import script from "./Article0013.vue?vue&type=script&lang=js&"
export * from "./Article0013.vue?vue&type=script&lang=js&"
import style0 from "./Article0013.vue?vue&type=style&index=0&id=6744f8f8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6744f8f8",
  null
  
)

export default component.exports